export const SITE_NAME = "中文字幕在线免费看";
export const SITE_SLOGAN = "高清中文字幕影视在线播放平台";
export const SITE_SHORT = "中文字幕";
export const CONTACT_EMAIL = "service@zimu-online.example";
export const CONTACT_WECHAT = "zimu-online-service";
export const NAV_LINKS = [
  { label: "首页", to: "/" },
  { label: "电影", to: "/category/movie" },
  { label: "电视剧", to: "/category/tv" },
  { label: "分类筛选", to: "/category/movie/filter" },
  { label: "关于我们", to: "/about" },
];